import { enqueueSnackbar, removeSnackbar } from '../general/actions';
import { dispatch } from '../../store';
import { AxiosResponse } from 'axios';
import { FirebaseError } from 'firebase';

export default class GeneralFunctions {
    public static generalShowError(ex : unknown, defaultMessage ?: string) {
        if (typeof ex === 'string' && ex) {
            return GeneralFunctions.generalShowErrorSnackbar(ex);
        }

        if (typeof ex === 'object' && ex instanceof Error) {
            return GeneralFunctions.generalShowErrorSnackbar(ex.message);
        }

        if (ex && typeof ex === 'object' && 'request' in ex) {
            const response = ex as AxiosResponse;

            if (response.config.responseType === 'blob') {
                (response.data as Blob).text().then((text) => {
                    GeneralFunctions.generalShowErrorSnackbar(text);
                }).catch(() => {
                    GeneralFunctions.generalShowErrorSnackbar(defaultMessage ?? '');
                });
                return;
            }

            return GeneralFunctions.generalShowErrorSnackbar(response.data ?? defaultMessage);
        }

        if (ex && typeof ex === 'object' && 'message' in ex) {
            const response = ex as Error | FirebaseError;
            return GeneralFunctions.generalShowErrorSnackbar(response.message);
        }

        return GeneralFunctions.generalShowErrorSnackbar(defaultMessage ?? '');
    }

    public static generalShowErrorSnackbar(message : string) {
        dispatch(enqueueSnackbar({
            message,
            options: {
                variant: 'error',
            },
        }));
    }

    public static generalShowErrorSnackbarV2(message : string, ex ?: any) {
        let errorMessage = message;

        if (ex) {
            if (typeof(ex) === 'string') {
                errorMessage = ex;
            } else if (typeof(ex.Message) === 'string') {
                errorMessage = ex.Message;
            } else if (typeof(ex.data?.Message) === 'string') {
                errorMessage = ex.data.Message;
            } else if (typeof(ex.response?.data?.Message) === 'string') {
                errorMessage = ex.response.data.Message;
            }
        }

        dispatch(enqueueSnackbar({
            message: errorMessage,
            options: {
                variant: 'error',
            },
        }));
    }
    
    public static generalShowSuccessSnackbar(message : string) {
        dispatch(enqueueSnackbar({
            message,
            options: {
                variant: 'success',
            },
        }));
    }
    
    public static generalShowWarningSnackbar(message : string) {
        dispatch(enqueueSnackbar({
            message,
            options: {
                variant: 'warning',
            },
        }));
    }
    
    public static generalShowInfoSnackbar(message : string) {
        dispatch(enqueueSnackbar({
            message,
            options: {
                variant: 'info',
            },
        }));
    }
    
    public static generalRemoveSnackbar(key : number) {
        dispatch(removeSnackbar(key));
    }

}
